import {createAsyncThunk} from '@reduxjs/toolkit';
import {getUserById, getUsers, getUsersCount} from '../../services/api/users.api';
import {deleteUserApi} from '../../services/api/user.api';
import RootState from "../states/root.state";

export const fetchUsers = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'user/list',
  async (params, {rejectWithValue, getState}) => {
    try {
      const {user} = getState();
      const token = user.accessToken;

      const response = await getUsers(token,params);
      return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching users.");
            } else {
                return rejectWithValue('An error occurred while fetching users.');
            }
        }
  }
);
export const fetchUserCount = createAsyncThunk<any, void, { rejectValue: string; state: RootState}>(
    'user/count',
    async (_, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await getUsersCount(token);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user count.");
            } else {
                return rejectWithValue('An error occurred while fetching user count.');
            }
        }
    }
);

export const fetchUserById= createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'user',
  async (id, {rejectWithValue, getState}) => {
      try {
        const {user} = getState();
        const token = user.accessToken;
  
        const response = await getUserById(token, id);
        return response.data;
      
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching user by id.");
            } else {
                return rejectWithValue('An error occurred while fetching user by id.');
            }
        }
  }
);

export const deleteUser = createAsyncThunk<any, {user_id: string, params?: string}, { rejectValue: string; state: RootState}>(
  'user/delete',
  async ({user_id, params}, {rejectWithValue, getState, dispatch}) => {
      try {
        const {user} = getState();
        const token = user.accessToken;
  
        const response = await deleteUserApi(token, user_id);
        
        // Refetch users list after successful deletion
        if (params) {
          dispatch(fetchUsers(params));
        }
        
        return {user_id, ...response.data};
      
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data?.message ?? error.response.data.message ?? error.response.data.error?.message ?? "An error occurred while deleting user.");
            } else {
                return rejectWithValue('An error occurred while deleting user.');
            }
        }
  }
);